import React, { useState } from 'react'
import { translate } from 'react-i18next';
import { connect } from "react-redux";
import { compose } from "redux";
import Call from '../../../hocs/call';
import { deleteDataBrowserDsdCache, hideDsdsListDsdLayoutAnnotations, readDsdsListDsds, showDsdsListDsdLayoutAnnotations } from './actions';
import InfiniteScrollTable from '../../../components/infinite-scroll-table';
import { TABLE_COL_MIN_WIDTH_ID, TABLE_COL_MIN_WIDTH_NAME } from '../../../styles/constants';
import { Icon, Modal } from 'antd';
import { BUTTON_DELETE, BUTTON_LAYOUT_ANNOTATIONS } from '../../../styles/buttons';
import { getStringFromArtefactTriplet } from '../../../utils/sdmxJson';
import { getArtefactTripletFromUrn } from '../../../utils/sdmxJson';
import LayoutAnnotationList from '../../../components/layout-annotation-list';
import { countLayoutAnnotations } from '../../../utils/annotations';

const mapStateToProps = state => ({
  dsds: state.scenes.dataManager.updataDatabrowserDsdCache.dsds,
  dsdLayoutAnnotations: state.scenes.dataManager.updataDatabrowserDsdCache.dsdLayoutAnnotations,
  dsdAnnotationTriplet: state.scenes.dataManager.updataDatabrowserDsdCache.dsdAnnotationTriplet,
  endpoints: state.config.nodes,
  endpointId: state.app.endpointId,
  appLanguage: state.app.language
});

const mapDispatchToProps = dispatch => ({
  fetchDsdsList: () => dispatch(readDsdsListDsds()),
  onDeleteDsdCache: (dsdIdsList) => dispatch(deleteDataBrowserDsdCache(dsdIdsList)),
  onLayoutAnnotationsShow: (annotations, triplet) => dispatch(showDsdsListDsdLayoutAnnotations(annotations, triplet)),
  onLayoutAnnotationsHide: () => dispatch(hideDsdsListDsdLayoutAnnotations())
});

const UpdateDatabrowserDsdCache = ({
  t,
  fetchDsdsList,
  dsds,
  dsdLayoutAnnotations,
  dsdAnnotationTriplet,
  onDeleteDsdCache,
  onLayoutAnnotationsShow,
  onLayoutAnnotationsHide,
  endpoints,
  endpointId
}) => {
  const annotationsConfig = endpoints.find(endpoint => endpoint.general.id === endpointId).annotations;
  const [selectedTableItems, setSelectedTableItems] = useState([])

  const onEditTableChange = (checkedArr) => {
    setSelectedTableItems(checkedArr)
  }

  return (
    <Call cb={fetchDsdsList} disabled={dsds !== null}>

      <InfiniteScrollTable
        data={dsds}
        columns={[
          {
            title: t('data.artefact.id.shortLabel'),
            dataIndex: 'id',
            minWidth: TABLE_COL_MIN_WIDTH_ID
          },
          {
            title: t('data.artefact.agencyID.shortLabel'),
            dataIndex: 'agencyID',
            widthToContent: true,
            withValuesFilter: true
          },
          {
            title: t('data.artefact.name.shortLabel'),
            dataIndex: 'name',
            minWidth: TABLE_COL_MIN_WIDTH_NAME
          },
          {
            title: t('data.artefact.version.shortLabel'),
            dataIndex: 'version',
            widthToContent: true,
            withValuesFilter: true
          },
          {
            title: t('data.artefact.isFinal.shortLabel'),
            dataIndex: "isFinal",
            width: 30,
            withValuesFilter: true,
            render: isFinal => isFinal
              ? <Icon type="check" />
              : null,
            renderText: isFinal => isFinal
              ? t('data.artefact.isFinal.values.final')
              : t('data.artefact.isFinal.values.notFinal')
          }
        ]}
        multilangStrDataIndexes={['name']}
        getRowKey={({ urn }) => urn}
        rowSelection={{
          selectedRowKeys: selectedTableItems || [],
          onChange: onEditTableChange
        }}
        actions={[{
          ...BUTTON_DELETE,
          title: t('scenes.dataManager.updateDatabrowserDsdCache.actions.deleteDsdCache.title'),
          onClick: ({ id, agencyID, version }) => Modal.confirm({
            title: t('scenes.dataManager.updateDatabrowserDsdCache.modals.confirms.deleteDsdCache', {
              triplet: getStringFromArtefactTriplet({ id, agencyID, version })
            }),
            onOk() {
              onDeleteDsdCache([getStringFromArtefactTriplet({ id, agencyID, version })]);
              setSelectedTableItems([])
            },
            cancelText: t('commons.buttons.cancel.title')
          })
        }]}
        tableActions={[{
          icon: "delete",
          title: t('scenes.dataManager.updateDatabrowserDsdCache.actions.deleteDsdsCache.title'),
          hasRectangularButton: true,
          onClick: () => {
            Modal.confirm({
              title: t('scenes.dataManager.updateDatabrowserDsdCache.actions.deleteDsdCaches.title', { numRecords: selectedTableItems.length }),
              onOk() {
                onDeleteDsdCache(selectedTableItems.map(urn => getStringFromArtefactTriplet(getArtefactTripletFromUrn(urn))))
                setSelectedTableItems([])
              },
              cancelText: t('commons.buttons.cancel.title')
            })
          }
        }]}
        fixedActions={[({ id, agencyID, version, annotations }) => {
          const layoutAnnotationsCount = countLayoutAnnotations(annotations, annotationsConfig);
          return (layoutAnnotationsCount > 0)
            ? ({
              ...BUTTON_LAYOUT_ANNOTATIONS,
              title: t('commons.actions.layoutAnnotations.title') + ": " + layoutAnnotationsCount,
              onClick: () => onLayoutAnnotationsShow(annotations, {
                id,
                agencyID,
                version
              })
            })
            : null;
        }]}
      />
      <LayoutAnnotationList
        annotations={dsdLayoutAnnotations}
        onClose={onLayoutAnnotationsHide}
        title={dsdAnnotationTriplet
          ? getStringFromArtefactTriplet(dsdAnnotationTriplet)
          : null
        }
      />
    </Call>
  )
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(UpdateDatabrowserDsdCache);